<template>
  <BFileUpload
    v-bind="$attrs"
    :upload-file="uploadFile"
    :value="value"
    accept="image/*"
    class="NotificationBannersFileInput"
    v-on="$listeners"
    @input="$emit('input', $event)"
  >
    <template v-if="value && value.url" #after>
      <v-col cols="auto">
        <img
          :src="value.url"
          class="NotificationBannersFileInput__image"
        >
      </v-col>
    </template>
  </BFileUpload>
</template>

<script>
import { FilesApi } from '@/api/resources'
import BFileUpload from '@/components/forms/BFileUpload.vue'


export default {
  name: 'NotificationBannersFileInput',
  components: {
    BFileUpload,
  },
  inheritAttrs: false,
  props: {
    value: Object,
  },
  methods: {
    async uploadFile(file) {
      const api = new FilesApi()
      this.isLoading = true

      try {
        const { data } = await api.upload(file)
        const url = URL.createObjectURL(file)
        return { url, ...data }
      } catch (e) {
        this.$notice.errors(e)
        return Promise.reject(e)
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style lang="scss">

.NotificationBannersFileInput {
  &__image {
    min-width: 300px;
    max-width: 300px;
  }
}
</style>
